<div class="wrap">
  <mat-spinner *ngIf="isLoading" color="primary" diameter="50"></mat-spinner>
  <p *ngIf="isLoading">Please wait, you will be redirected...</p>
  <video
    id="videoPlayer"
    #videoElement
    controls="true"
    autoplay
    [src]="url"
    *ngIf="!isLoading"
  ></video>

  <div class="layout-horizontal" *ngIf="!isLoading">
    <button
      mat-raised-button
      color="primary"
      class="downloadBtn"
      (click)="takeSnapshot()"
    >
      Download Snapshot
    </button>
    <button
      mat-raised-button
      color="primary"
      class="downloadBtn"
      [disabled]="!canUseAnpr"
      (click)="onClickAnpr()"
    >
      Send picture to ANPR
    </button>
    <canvas id="canvas" width="640" height="360" style="display: none"></canvas>
  </div>
</div>
